import { faAward } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { ColorValue, StyleProp, View, ViewStyle } from 'react-native';

import useStyles from '../../../hooks/styles-hook';
import { useAppSelector } from '../../../hooks/store-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import Label, { LabelType } from '../Label';
import MoreInfoButton, { MoreInfoButtonProps } from '../MoreInfoButton';
import { formatMissionCurrency } from '../../../helpers/missionCompensation';

interface MissionRemunerationSummaryProps {
  amount?: number | string;
  points?: number;
  pointsOnly?: boolean;
  label?: string;
  totalPaymentMaxAmount?: number | null;
  textColor?: ColorValue;
  iconColor?: ColorValue;
  helpColor?: string;
  rowStyle?: StyleProp<ViewStyle>;
  moreInfoButtonProps?: Pick<MoreInfoButtonProps, 'suspendDrawerOnOpen' | 'useLightBoxOnNative' | 'onOpen'>;
}

const MissionRemunerationSummary = ({ amount, points, pointsOnly = false, label, totalPaymentMaxAmount, textColor, iconColor, helpColor, rowStyle, moreInfoButtonProps }: MissionRemunerationSummaryProps) => {
  const t = useTranslation();
  const uiLanguage = useAppSelector((state) => state.userPrefs.uiLanguage);
  const theme = useCustomTheme();
  const styles = useStyles((section) => section.missionDetailCard);
  const localizedAmount = formatMissionCurrency(amount, uiLanguage);
  const totalPaymentLimit = typeof totalPaymentMaxAmount === 'number' && Number.isFinite(totalPaymentMaxAmount)
    ? t('at-home-total-payment-cap', {
      amount: new Intl.NumberFormat(uiLanguage?.startsWith('fr') ? 'fr-CA' : 'en-CA', {
        style: 'currency', currency: 'CAD',
      }).format(totalPaymentMaxAmount),
    })
    : undefined;
  const helpText = [t('help.points-rate'), totalPaymentLimit].filter(Boolean).join('\n\n');

  return (
    <View style={[styles.missionsBranchDetail.content.infoContainer.summaryItem, rowStyle]}>
      <FontAwesomeIcon
        icon={faAward}
        color={(iconColor ?? theme.text.primary).toString()}
        style={styles.missionsBranchDetail.content.infoContainer.summaryItemIcon}
        size={20}
      />
      <View style={[styles.missionsBranchDetail.content.infoContainer.summaryItemValueSecondary, { flex: 1, minWidth: 0, alignItems: 'center' }]}>
        <Label numberOfLines={0} variant={LabelType.valueLargeMission} style={{ marginLeft: 6, flexShrink: 1, ...(textColor ? { color: textColor } : {}) }}>
          {pointsOnly ? t('points-value', { value: points ?? 0 }) : localizedAmount}
        </Label>
        <Label numberOfLines={0} variant={LabelType.titleDarkSmall} style={{ flex: 1, minWidth: 0, marginLeft: 12, fontWeight: '700', ...(textColor ? { color: textColor } : {}) }}>
          {label ?? t('salary')}{!pointsOnly && points !== undefined ? ` (${points} pts)` : ''}
        </Label>
      </View>
      <MoreInfoButton {...moreInfoButtonProps} style={{ alignSelf: 'center', marginLeft: 8, flexShrink: 0 }} title={''}
        color={helpColor} openURL="rewards-link-lanla-website-support">
        {helpText}
      </MoreInfoButton>
    </View>
  );
};

export default MissionRemunerationSummary;
